/**
 * Self-service account security (password change) — BFF /me/change-password.
 */

import { tenantApiFetch, tenantDashboardPath } from "@/lib/tenantApi";

const CHANGE_PASSWORD_PATH = tenantDashboardPath("/me/change-password");

export class PersonalAccountSecurityClient {
  /**
   * @param {{ currentPassword: string, newPassword: string }} payload
   * @returns {Promise<{ success: boolean, message?: string }>}
   */
  async changePassword(payload) {
    return tenantApiFetch(CHANGE_PASSWORD_PATH, {
      method: "POST",
      body: JSON.stringify({
        currentPassword: payload.currentPassword,
        newPassword: payload.newPassword,
      }),
    });
  }
}
